import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import {
  GetReportDistributorGameParams,
  getReportDistributorGame,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {ValidationEnum} from "../../../enums/validationEnum";

const ReportDistributorGame: FC = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validations={[
          ValidationEnum.VALIDATE_SMART_SEARCH,
          ValidationEnum.VALIDATE_SEARCH,
      ]}
      validOnEmpty={false}
      onRefresh={(output, params, startDateInterval, endDateInterval) => {
        const getReportDistributorGameParams: GetReportDistributorGameParams = {
          name:"Distributor Game",
          output,
          dateIntervalStart: startDateInterval.format("MM-DD-YYYY"),
          dateIntervalEnd: endDateInterval.format("MM-DD-YYYY"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getReportDistributorGameParams[id] = params.id;
        }

        return getReportDistributorGame(getReportDistributorGameParams);
      }}
    />
  );
};

export default ReportDistributorGame;
